import { UserRole } from '../../types';
import { ProjectTask } from '../../services/projectService';

export const isUserOnTask = (task: ProjectTask, userId?: string) => {
  if (!userId) return false;
  if (task.assignedTo?._id === userId) return true;
  if (task.createdBy?._id === userId) return true;
  return (task.participants || []).some((person) => person._id === userId);
};

export const canOpenProjectTask = (
  task: ProjectTask,
  user?: { _id: string; role?: string } | null,
  canManage = false
) => {
  if (!user) return false;
  if (user.role === UserRole.SUPER_ADMIN) return true;
  if (canManage) return true;
  return isUserOnTask(task, user._id);
};
